export default __webpack_public_path__ + "static/media/golf-starterpack-pasture.4bed1995.png";